import { render, staticRenderFns } from "./bookingDoneDialog.vue?vue&type=template&id=2b1d4f76&scoped=true&"
import script from "./bookingDoneDialog.vue?vue&type=script&lang=js&"
export * from "./bookingDoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./bookingDoneDialog.vue?vue&type=style&index=0&id=2b1d4f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d4f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1d4f76')) {
      api.createRecord('2b1d4f76', component.options)
    } else {
      api.reload('2b1d4f76', component.options)
    }
    module.hot.accept("./bookingDoneDialog.vue?vue&type=template&id=2b1d4f76&scoped=true&", function () {
      api.rerender('2b1d4f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/routeCentral/bookingDoneDialog.vue"
export default component.exports